module.exports = __webpack_public_path__ + "img/02.afa29df5.png";